import * as Device from './device';

export default Device;
